import { getPercentValue } from "../components/Progress/Progress";

export const getProgressDiscount = (
  base: number,
  progressValue: number,
  progressCount: number,
  unitDiscount: number,
  currencyTitle: string
) => {
  const percentValue = Math.round(
    (getPercentValue({
      value: progressValue,
      count: progressCount,
    }) *
      base) /
      100
  );

  return unitDiscount === 2
    ? `${percentValue}${currencyTitle ?? ""}`
    : `${percentValue}%`;
};
